'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ContactInfo, _Component);

  function ContactInfo(props) {
    (0, _classCallCheck3.default)(this, ContactInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContactInfo.__proto__ || (0, _getPrototypeOf2.default)(ContactInfo)).call(this, props));

    _this.state = { showProvince: false, showDistrict: false, showInfo: false };

    _this.onChangeProvince = function (province) {
      _this.props.onChangeProvince(province);
    };

    _this.onChangeDistrict = function (district) {
      _this.props.onChangeDistrict(district);
    };

    _this.onChangeAddress = function (event) {
      _this.props.onChangeAddress(event.target.value);
    };

    _this.showProvince = _this.showProvince.bind(_this);
    _this.hideProvince = _this.hideProvince.bind(_this);
    _this.showDistrict = _this.showDistrict.bind(_this);
    _this.hideDistrict = _this.hideDistrict.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ContactInfo, [{
    key: 'onChange',
    value: function onChange(key, e) {
      var value = e.target.value;
      this.props.onChange(key, value);
    }
  }, {
    key: 'showProvince',
    value: function showProvince() {
      this.setState({ showProvince: true });
    }
  }, {
    key: 'hideProvince',
    value: function hideProvince() {
      this.setState({ showProvince: false });
    }
  }, {
    key: 'showDistrict',
    value: function showDistrict() {
      var districts = this.props.data.districts;

      if (districts) {
        this.setState({ showDistrict: true });
      }
    }
  }, {
    key: 'hideDistrict',
    value: function hideDistrict() {
      this.setState({ showDistrict: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ContactInfo.scss');
      var _props$data = this.props.data,
          name = _props$data.name,
          phone = _props$data.phone,
          provinces = _props$data.provinces,
          districts = _props$data.districts,
          atHome = _props$data.atHome,
          province = _props$data.province,
          district = _props$data.district,
          address = _props$data.address,
          isFreelance = _props$data.isFreelance;
      var _state = this.state,
          showProvince = _state.showProvince,
          showDistrict = _state.showDistrict;

      var displayDistrict = district && (0, _extends3.default)({}, district, {
        name: district.name.length < 5 ? district.type + ' ' + district.name : district.name
      });
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.boxHead },
          _react2.default.createElement(
            'label',
            null,
            'Th\xF4ng tin li\xEAn h\u1EC7'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.boxContent },
          _react2.default.createElement(
            'div',
            { className: styles.userInfoBox },
            _react2.default.createElement('img', { src: '/booking/edit.png', alt: '', className: styles.editIcon }),
            _react2.default.createElement(_components.GroupInput, {
              label: 'T\xEAn',
              value: name,
              onChange: function onChange(e) {
                return _this2.onChange('name', e);
              }
            }),
            _react2.default.createElement(_components.GroupInput, {
              className: styles.marginTop,
              label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i',
              value: phone,
              onChange: function onChange(e) {
                return _this2.onChange('phone', e);
              }
            })
          ),
          atHome && _react2.default.createElement(
            'div',
            { className: styles.addressBox },
            _react2.default.createElement(
              'div',
              { className: styles.provinceBox },
              _react2.default.createElement(
                'div',
                { className: styles.province },
                _react2.default.createElement(
                  'label',
                  null,
                  'Th\xE0nh ph\u1ED1'
                ),
                _react2.default.createElement(_components.SelectShop, {
                  disable: isFreelance,
                  isBookingAddress: true,
                  show: showProvince,
                  data: provinces,
                  activeShop: province,
                  placeHolder: 'Th\xE0nh ph\u1ED1',
                  titleOverlay: 'Ch\u1ECDn th\xE0nh ph\u1ED1',
                  onHide: this.hideProvince,
                  onShow: this.showProvince,
                  onChange: this.onChangeProvince,
                  className: styles.selectAddress
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.district },
                _react2.default.createElement(
                  'label',
                  null,
                  'Qu\u1EADn huy\u1EC7n'
                ),
                _react2.default.createElement(_components.SelectShop, {
                  isBookingAddress: true,
                  show: showDistrict,
                  data: districts,
                  activeShop: displayDistrict,
                  placeHolder: 'Qu\u1EADn huy\u1EC7n',
                  titleOverlay: 'Ch\u1ECDn qu\u1EADn huy\u1EC7n',
                  onHide: this.hideDistrict,
                  onShow: this.showDistrict,
                  onChange: this.onChangeDistrict,
                  className: styles.selectAddress
                })
              )
            ),
            _react2.default.createElement(_components.GroupInput, {
              className: styles.marginTop,
              label: 'S\u1ED1 nh\xE0, t\xEAn \u0111\u01B0\u1EDDng',
              value: address,
              onChange: this.onChangeAddress
            })
          )
        )
      );
    }
  }]);
  return ContactInfo;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  provinces: _react.PropTypes.array,
  districts: _react.PropTypes.array,
  atHome: _react.PropTypes.bool,
  // Actions
  onChangeProvince: _react.PropTypes.func,
  onChangeDistrict: _react.PropTypes.func,
  onChangeAddress: _react.PropTypes.func,
  onChange: _react.PropTypes.func
}, _temp);
exports.default = ContactInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ContactInfo.js
// module id = 1555
// module chunks = 0